module.exports = new __parcel__URL__("BrickVideoStudio.66129c08.jpeg").toString();